import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      /**
       * @description Настройки столбцов таблицы.
       * @type {any[]}
       */
      tableColumnSettings: [],
      /**
       * @description Столбцы таблицы.
       * @type {any[]}
       */
      tableColumns: [],
    };
  },
  methods: {
    /**
     * @description Получить настройки таблицы.
     * @param {string} tableId
     * @returns {void}
     */
    fetchTableSettings(tableId) {
      const onSuccess = (response) => {
        this.tableColumnSettings = response.columns;
      };
      this
        .$suggestionGateway
        .viewTableSettings(tableId)
        .then((result) => result.forEach(onSuccess));
    },
    /**
     * @description Сохранить настройки таблицы.
     * @param {string} tableId
     * @returns {void}
     */
    storeTableSettings: debounce(function _(tableId) {
      const onFail = () => {};
      this
        .$suggestionGateway
        .storeTableSettings(tableId, this.tableColumnSettings)
        .then((result) => result.forEachLeft(onFail));
    }, 300),
    /**
     * @description Обработать изменение настроек столбцов таблицы.
     * @param {string} tableId
     * @param {any[]}  columns
     * @returns {void}
     */
    onChangeColumnSettings(tableId, columns) {
      this.tableColumnSettings = columns;
      this.tableColumns = this.tableColumns.map((candidate) => {
        const column = columns.find(({ id }) => candidate.id === id);
        if (column) {
          return { ...candidate, is_visible: column.is_visible };
        }
        return candidate;
      });
      this.storeTableSettings(tableId);
    },
  },
};
